<script setup lang="ts">
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import gsap from 'gsap';

gsap.registerPlugin(ScrollTrigger, SplitText);

const nuxtApp = useNuxtApp();
const i18n = useI18n();

// Load and provide shared data
const localePaths = await useLocalePaths();
nuxtApp.provide('LocalePaths', localePaths);

const { data: siteInfoData } = await useAsyncGql({
  operation: 'GetSiteInfo',
  variables: { locale: i18n.localeProperties.value.siteLocale },
});

const { data: faqCategoriesData } = await useAsyncGql({
  operation: 'GetAllFaqCategories',
  variables: { locale: i18n.localeProperties.value.siteLocale },
});

nuxtApp.provide('siteInfo', siteInfoData.value?.siteInfo);
nuxtApp.provide('faqCategories', faqCategoriesData.value?.allFaqCategories);

useHead({
  title: siteInfoData.value?.siteInfo?.pageTitle,
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/favicon-96x96.png',
      sizes: '96x96',
    },
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'shortcut icon', href: '/favicon.ico' },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/apple-touch-icon.png',
    },
    { rel: 'manifest', href: '/site.webmanifest' },
  ],
  meta: [{ name: 'apple-mobile-web-app-title', content: 'ROZ' }],
  script: [
    {
      key: 'tracking',
      src: '/scripts/tracking.js',
      async: true,
    },
  ],
});

onMounted(() => {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollbarWidth}px`,
    );
  }
});
</script>

<template>
  <div class="nuxt-app">
    <NuxtPage />
  </div>
</template>
